import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Challenges from './components/Challenges';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import CaseStudies from './components/CaseStudies';
import Stats from './components/Stats';
import CompanyProfile from './components/CompanyProfile';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { ThemeProvider } from './ThemeContext';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
        <Header />
        <main>
          <Hero />
          <Challenges />
          <Services />
          <CaseStudies />
          <WhyUs />
          <Stats />
          <CompanyProfile />
          <Contact />
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
